import React, { Component } from 'react';
import TournamentOverlay, { Aviso } from './TournamentOverlay';
import { MOTIVO_BAJA } from '../utils/tournamentsApi';

const ORIGEN = { torneo: 'cargado acá', entrada: 'de la entrada del evento', perfil: 'del perfil de su cuenta' };

// Editar un participante: nombre, grupo ("familia Pérez": el armado evita sentarlos juntos),
// contacto para el reporte a Devir y si se le informó el uso de sus datos y fotos.
//
// El correo y el teléfono que se cargan acá GANAN sobre los de la entrada y el perfil. Si el campo
// queda vacío se usa el de la entrada o el del perfil (se muestra de dónde sale).
class ParticipantEditModal extends Component {
    constructor(props) {
        super(props);
        const p = props.participant;
        this.state = {
            displayName: p.display_name || '',
            affinityGroup: p.affinity_group || '',
            email: p.email || '',
            phone: p.phone || '',
            consent: !!p.consent_at,
            status: p.status,
            droppedReason: p.dropped_reason || '',
            saving: false,
            error: null,
        };
    }

    guardar = async () => {
        const p = this.props.participant;
        const s = this.state;
        const payload = {};
        if (s.displayName.trim() !== p.display_name) payload.displayName = s.displayName;
        if ((s.affinityGroup || '') !== (p.affinity_group || '')) payload.affinityGroup = s.affinityGroup;
        if ((s.email || '') !== (p.email || '')) payload.email = s.email;
        if ((s.phone || '') !== (p.phone || '')) payload.phone = s.phone;
        if (s.consent !== !!p.consent_at) payload.consent = s.consent;
        if (s.status !== p.status) payload.status = s.status;
        const reason = s.status === 'dropped' ? (s.droppedReason || null) : null;
        if (s.status === 'dropped' && reason !== (p.dropped_reason || null)) payload.droppedReason = reason;
        if (!Object.keys(payload).length) { this.props.onClose(); return; }
        this.setState({ saving: true, error: null });
        try {
            await this.props.onSave(payload);
        } catch (e) {
            this.setState({ saving: false, error: e.message });
        }
    }

    render() {
        const c = this.props.contact || {};
        const s = this.state;
        const grupos = this.props.grupos || [];
        return (
            <TournamentOverlay title={`Participante · ${this.props.participant.display_name}`} onClose={this.props.onClose}
                footer={(
                    <button type="button" className="btn btn-accent" disabled={s.saving} onClick={this.guardar}>
                        {s.saving ? 'Guardando…' : 'Guardar'}
                    </button>
                )}>
                {s.error ? <Aviso tipo="error">{s.error}</Aviso> : null}
                <div className="form-group">
                    <label>Nombre</label>
                    <input type="text" className="form-control" value={s.displayName}
                        onChange={(e) => this.setState({ displayName: e.target.value })} />
                </div>
                <div className="form-group">
                    <label>Grupo (amigos o familia)</label>
                    <input type="text" className="form-control" list="grupos-torneo" value={s.affinityGroup}
                        placeholder="Familia Pérez"
                        onChange={(e) => this.setState({ affinityGroup: e.target.value })} />
                    <datalist id="grupos-torneo">{grupos.map((g) => <option key={g} value={g} />)}</datalist>
                    <small className="text-muted">Los del mismo grupo se evitan en la misma mesa, si se puede (las bases lo piden).</small>
                </div>
                <div className="row">
                    <div className="col-md-6 form-group">
                        <label>Correo</label>
                        <input type="email" className="form-control" value={s.email}
                            placeholder={c.email && c.emailSource !== 'torneo' ? c.email : ''}
                            onChange={(e) => this.setState({ email: e.target.value })} />
                        {c.email && c.emailSource !== 'torneo' && !s.email ? (
                            <small className="text-muted">Se usa {c.email}, {ORIGEN[c.emailSource]}.</small>
                        ) : null}
                    </div>
                    <div className="col-md-6 form-group">
                        <label>Teléfono</label>
                        <input type="tel" className="form-control" value={s.phone}
                            placeholder={c.phone && c.phoneSource !== 'torneo' ? c.phone : ''}
                            onChange={(e) => this.setState({ phone: e.target.value })} />
                        {c.phone && c.phoneSource !== 'torneo' && !s.phone ? (
                            <small className="text-muted">Se usa {c.phone}, {ORIGEN[c.phoneSource]}.</small>
                        ) : null}
                    </div>
                </div>
                <div className="form-group">
                    <label className="d-flex align-items-center" style={{ gap: 8, cursor: 'pointer' }}>
                        <input type="checkbox" checked={s.consent} onChange={(e) => this.setState({ consent: e.target.checked })} />
                        Se le informó que Devir va a usar sus datos y las fotos del evento
                    </label>
                </div>
                <div className="row">
                    <div className="col-md-6 form-group">
                        <label>Estado</label>
                        <select className="form-control" value={s.status} onChange={(e) => this.setState({ status: e.target.value })}>
                            <option value="active">Juega</option>
                            <option value="dropped">Dado de baja</option>
                        </select>
                    </div>
                    {s.status === 'dropped' ? (
                        <div className="col-md-6 form-group">
                            <label>Motivo</label>
                            <select className="form-control" value={s.droppedReason} onChange={(e) => this.setState({ droppedReason: e.target.value })}>
                                <option value="">Sin motivo</option>
                                {Object.keys(MOTIVO_BAJA).map((k) => <option key={k} value={k}>{MOTIVO_BAJA[k]}</option>)}
                            </select>
                        </div>
                    ) : null}
                </div>
            </TournamentOverlay>
        );
    }
}

export default ParticipantEditModal;
